import type {
	FilterOrFilterGroupConfig,
	FiltersConfig,
} from "hsl-core/FundExplorer";

export default function getFilterKeys(filters: FiltersConfig["filters"]) {
	function getFilterKeysRecursive(
		filtersList: FilterOrFilterGroupConfig[],
	): string[] {
		return filtersList.reduce((keys, filter) => {
			if (filter.type === "group") {
				const innerKeys = getFilterKeysRecursive(filter.filters);
				keys.push(...innerKeys);
			} else if (filter.type === "single") {
				keys.push(filter.key);
			}
			return keys;
		}, [] as string[]);
	}

	return getFilterKeysRecursive(filters);
}
